import Axios from '../../library/Axios'

export const ContactPostAction = (name: string, mobile: string, subject: string, message: string) => async (dispatch: any, onComplete: any) => {
    try {
        dispatch({ type: 'CONTACT_POST_REQUEST' })

        const { data } = await new Axios().post(`/post/submit/contact`, {
            name: name,
            mobile: mobile,
            subject: subject,
            message: message
        })

        dispatch({
            type: 'CONTACT_POST_SUCCESS', payload: data
        })
    } catch (error) {
        // console.log(error)
    }
}